import { v4 as uuid } from "uuid";

/**
 * Product Database can be added here.
 * You can add products of your wish with different attributes
 * */

export const products = [
	{
		_id: uuid(),
		title: "Sun Painting",
		price: 990,
		rating: 4,
		img: "https://aipan-store.netlify.app/assets/paintings/sun-painting.jpg",
		categoryName: "paintings",
	},
	{
		_id: uuid(),
		title: "Cotton Fabric Bag",
		price: 760,
		rating: 2,
		img: "https://aipan-store.netlify.app/assets/bags/bag1.jpg",
		categoryName: "bags",
	},
	{
		_id: uuid(),
		title: "Handmade Diary",
		price: 560,
		rating: 2,
		img: "https://aipan-store.netlify.app/assets//diary/diary2.jpg",
		categoryName: "diary",
	},
	{
		_id: uuid(),
		title: "Handcrafted tea coaster",
		price: 740,
		rating: 3,
		img: "https://aipan-store.netlify.app/assets/coaster/coaster2.jpg",
		categoryName: "coaster",
	},
	{
		_id: uuid(),
		title: "Handcrafted square coaster",
		price: 890,
		rating: 3,
		img: "https://aipan-store.netlify.app/assets/coaster/coaster1.jpg",
		categoryName: "coaster",
	},
	{
		_id: uuid(),
		title: "Handmade Diary",
		price: 560,
		rating: 4,
		img: "https://aipan-store.netlify.app/assets/diary/diary3.jpg",
		categoryName: "diary",
	},
	{
		_id: uuid(),
		title: "Cotton Fabric Bag",
		price: 760,
		rating: 2,
		img: "https://aipan-store.netlify.app/assets/bags/bag2.jpg",
		categoryName: "bags",
	},
	{
		_id: uuid(),
		title: "Aipan Painting",
		price: 2200,
		rating: 5,
		img: "https://aipan-store.netlify.app/assets/paintings/painting1.jpg",
		categoryName: "paintings",
	},
	{
		_id: uuid(),
		title: "Khadi Cotton Bag",
		price: 840,
		rating: 3.5,
		img: "https://aipan-store.netlify.app/assets/bags/bag5.jpeg",
		categoryName: "bags",
	},
	{
		_id: uuid(),
		title: "Handcrafted round coaster",
		price: 740,
		rating: 3,
		img: "https://aipan-store.netlify.app/assets/coaster/coaster4.jpg",
		categoryName: "coaster",
	},
	{
		_id: uuid(),
		title: "Lord Buddha Wall Painting",
		price: 1200,
		rating: 4.5,
		img: "https://aipan-store.netlify.app/assets/paintings/lord-budha-wall-painting.jpg",
		categoryName: "paintings",
	},
	{
		_id: uuid(),
		title: "Seven Chakra Flexi Notebook",
		price: 640,
		rating: 3.5,
		img: "https://aipan-store.netlify.app/assets/diary/diary4.jpg",
		categoryName: "diary",
	},
	{
		_id: uuid(),
		title: "Goddess Saraswati Painting",
		price: 3200,
		rating: 5,
		img: "https://aipan-store.netlify.app/assets/paintings/saraswati-painting.jpg",
		categoryName: "paintings",
	},
	{
		_id: uuid(),
		title: "Beautiful Tote Bag",
		price: 760,
		rating: 2.5,
		img: "https://aipan-store.netlify.app/assets/bags/bag4.jpg",
		categoryName: "bags",
	},
	{
		_id: uuid(),
		title: "Handcrafted tea coaster",
		price: 740,
		rating: 3,
		img: "https://aipan-store.netlify.app/assets/coaster/coaster5.jpg",
		categoryName: "coaster",
	},
	{
		_id: uuid(),
		title: "Folk Dance Painting",
		price: 4000,
		rating: 5,
		img: "https://aipan-store.netlify.app/assets/paintings/folk-dance-painting.jpg",
		categoryName: "paintings",
	},
	{
		_id: uuid(),
		title: "Handcrafted round coaster",
		price: 740,
		rating: 3,
		img: "https://aipan-store.netlify.app/assets/coaster/coaster6.jpg",
		categoryName: "coaster",
	},
	{
		_id: uuid(),
		title: "Handmade Diary",
		price: 560,
		rating: 4,
		img: "https://aipan-store.netlify.app/assets/diary/diary5.jpg",
		categoryName: "diary",
	},
	{
		_id: uuid(),
		title: "Sun Face Aipan Painting",
		price: 3800,
		rating: 4.7,
		img: "https://aipan-store.netlify.app/assets/paintings/sun-face-painting.jpg",
		categoryName: "paintings",
	},
	{
		_id: uuid(),
		title: "Cotton Fabric Bag",
		price: 740,
		rating: 4.2,
		img: "https://aipan-store.netlify.app/assets/bags/bag3.jpg",
		categoryName: "bags",
	},
];
